const appConfig = {
  GOOGLE_MAPS_API_KEY: "AIzaSyBV9I7IJhaLGsNn4C4yjTwzTgdtlYpIZJU",
  GOOGLE_OAUTH_CLIENT_ID: "634820308489-qa4lnj89noo3b9a4gejp0bgob0t0to61.apps.googleusercontent.com",
  IS_WHITELABEL_MODE: true,
  currency: "€",
}

export default appConfig;